require("./bootstrap");
require("./swiper");
require("./aos");
require("./main-navigation");
require("./backend");

// Template specific
require("./templates/master");
require("./templates/support");
require("./templates/product");
require("./templates/marketing-directory");

$(window).scroll(function () {
    const scroll = $(window).scrollTop();
    $("[data-scroll-detection]").toggleClass("scrolled", scroll > 0);
});
